import { render } from "./PostIssuePropertyComponent.vue?vue&type=template&id=6bc1236b&scoped=true&ts=true"
import script from "./PostIssuePropertyComponent.vue?vue&type=script&lang=ts"
export * from "./PostIssuePropertyComponent.vue?vue&type=script&lang=ts"

import "./PostIssuePropertyComponent.vue?vue&type=style&index=0&id=6bc1236b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc1236b"]])

export default __exports__